export const VTE_RISK_FACTOR_EVALUATION = {
    title: "vte-risk-factor-evaluation.vte-risk-factor-evaluation",
    masterTableName: "MC_VTE_RISK_FACTOR_EVAL",
    tableName: "MC_VTE_RISK_FACTOR_EVAL_DETAIL",
    columnName: "VRFE_ID",
    columnValue: 0,
    formData: {
        VRFE_ID: "",
        PROCESS_TIME: new Date(),
        CTIME: new Date(),
        CUSER: "",
        GENERAL_NOTE: "",
        CALC_VALUE: 0,
        HEIGHT: 0,
        WEIGHT: 0,
        VKI: 0,
        AGE_PD_ID: null,
        MINOR_SURGERY: null,
        PASSED_MAJOR_SURGERY: null,
        VARICOSE_VEINS: null,
        INFLMMATRY_INTSTL_DISSE_STRY: null,
        LEG_SWELLING_PRESENCE: null,
        VKI_PD_ID: null,
        ACUTE_MYOCARDIAL_INFECTION: null,
        CONGESTIVE_HEART_FAILURE: null,
        DIABETES_MELLITUS_HYPERTENSION: null,
        SEPSIS: null,
        PNEUMONIA: null,
        SERIOUS_PULMONARY_DISEASE: null,
        CHRNC_OBSTRCTVE_PLMNRY_DISEASE: null,
        PATIENT_REQUIRING_BED_REST: null,
        BRTH_CNTRL_PHRM_OR_HRMN_USE: null,
        PREGNANCY_OR_POSTPARTUM: null,
        MISCARRIAGE_OR_STILLBIRTH: null,
        SPINE_SURGERY: null,
        ARTHROSCOPIC_SURGERY: null,
        ENDOSCOPIC_UROLOGICL_SURGERY: null,
        MALIGNANCY: null,
        MAJOR_SURGERY: null,
        LAPAROSCOPIC_SURGERY: null,
        BEDRIDDEN_PATIENT: null,
        IMMOBILIZATION: null,
        CENTRAL_VENOUS_CATATER: null,
        PATIENT_USING_ANTIAGREGAN: null,
        OPERA_HEART_SURGERY: null,
        DVT_PE_STORY: null,
        FAMILY_THROMBOSIS_STORY: null,
        HEPARININDUCED_THROMBCYTOPNI: null,
        CONJENTIAL_THROMBOPHILE_FACTRS: null,
        MYELOPROLIFERATIVE_DISEASE: null,
        ELKTF_MJR_XTRMT_RTRPLY_SURGERY: null,
        HIP_PLVS_R_LWR_XTRMTY_FRACTURE: null,
        STROKE: null,
        MULTIPL_TRAUMA: null,
        ACUTE_SPINAL_CORD_INJURY: null,
    },
    fields: [
        {
            field: "PROCESS_TIME",
            headerName: "datetime",
            flex: 1,
        },
        { field: "HEIGHT", headerName: "vte-risk-factor-evaluation.height", flex: 1 },
        { field: "WEIGHT", headerName: "vte-risk-factor-evaluation.weight", flex: 1 },
        { field: "VKI", headerName: "vte-risk-factor-evaluation.vki", flex: 1 },
        { field: "AGE_PD_ID", headerName: "vte-risk-factor-evaluation.age", flex: 1 },
        { field: "MINOR_SURGERY", headerName: "vte-risk-factor-evaluation.minor-surgery", flex: 1 },
        { field: "PASSED_MAJOR_SURGERY", headerName: "vte-risk-factor-evaluation.passed-major-surgery", flex: 1 },
        { field: "VARICOSE_VEINS", headerName: "vte-risk-factor-evaluation.varicose-veins", flex: 1 },
        { field: "INFLMMATRY_INTSTL_DISSE_STRY", headerName: "vte-risk-factor-evaluation.inflammatory-intestinal-disease", flex: 1 },
        { field: "LEG_SWELLING_PRESENCE", headerName: "vte-risk-factor-evaluation.leg-swelling", flex: 1 },
        { field: "VKI_PD_ID", headerName: "vte-risk-factor-evaluation.bmi-score", flex: 1 },
        { field: "ACUTE_MYOCARDIAL_INFECTION", headerName: "vte-risk-factor-evaluation.acute-myocardial-infarction", flex: 1 },
        { field: "CONGESTIVE_HEART_FAILURE", headerName: "vte-risk-factor-evaluation.congestive-heart-failure", flex: 1 },
        { field: "DIABETES_MELLITUS_HYPERTENSION", headerName: "vte-risk-factor-evaluation.diabetes-hypertension", flex: 1 },
        { field: "SEPSIS", headerName: "vte-risk-factor-evaluation.sepsis", flex: 1 },
        { field: "PNEUMONIA", headerName: "vte-risk-factor-evaluation.pneumonia", flex: 1 },
        { field: "SERIOUS_PULMONARY_DISEASE", headerName: "vte-risk-factor-evaluation.serious-pulmonary-disease", flex: 1 },
        { field: "CHRNC_OBSTRCTVE_PLMNRY_DISEASE", headerName: "vte-risk-factor-evaluation.copd", flex: 1 },
        { field: "PATIENT_REQUIRING_BED_REST", headerName: "vte-risk-factor-evaluation.bed-rest-required", flex: 1 },
        { field: "BRTH_CNTRL_PHRM_OR_HRMN_USE", headerName: "vte-risk-factor-evaluation.birth-control-hormone-use", flex: 1 },
        { field: "PREGNANCY_OR_POSTPARTUM", headerName: "vte-risk-factor-evaluation.pregnancy-postpartum", flex: 1 },
        { field: "MISCARRIAGE_OR_STILLBIRTH", headerName: "vte-risk-factor-evaluation.miscarriage-stillbirth", flex: 1 },
        { field: "SPINE_SURGERY", headerName: "vte-risk-factor-evaluation.spine-surgery", flex: 1 },
        { field: "ARTHROSCOPIC_SURGERY", headerName: "vte-risk-factor-evaluation.arthroscopic-surgery", flex: 1 },
        { field: "ENDOSCOPIC_UROLOGICL_SURGERY", headerName: "vte-risk-factor-evaluation.endoscopic-urologic-surgery", flex: 1 },
        { field: "MALIGNANCY", headerName: "vte-risk-factor-evaluation.malignancy", flex: 1 },
        { field: "MAJOR_SURGERY", headerName: "vte-risk-factor-evaluation.major-surgery", flex: 1 },
        { field: "LAPAROSCOPIC_SURGERY", headerName: "vte-risk-factor-evaluation.laparoscopic-surgery", flex: 1 },
        { field: "BEDRIDDEN_PATIENT", headerName: "vte-risk-factor-evaluation.bedridden-patient", flex: 1 },
        { field: "IMMOBILIZATION", headerName: "vte-risk-factor-evaluation.immobilization", flex: 1 },
        { field: "CENTRAL_VENOUS_CATATER", headerName: "vte-risk-factor-evaluation.central-venous-catheter", flex: 1 },
        { field: "PATIENT_USING_ANTIAGREGAN", headerName: "vte-risk-factor-evaluation.patient-using-antiaggregant", flex: 1 },
        { field: "OPERA_HEART_SURGERY", headerName: "vte-risk-factor-evaluation.open-heart-surgery", flex: 1 },
        { field: "DVT_PE_STORY", headerName: "vte-risk-factor-evaluation.dvt-pe-history", flex: 1 },
        { field: "FAMILY_THROMBOSIS_STORY", headerName: "vte-risk-factor-evaluation.family-thrombosis-history", flex: 1 },
        { field: "HEPARININDUCED_THROMBCYTOPNI", headerName: "vte-risk-factor-evaluation.heparin-induced-thrombocytopenia", flex: 1 },
        { field: "CONJENTIAL_THROMBOPHILE_FACTRS", headerName: "vte-risk-factor-evaluation.congenital-thrombophilia", flex: 1 },
        { field: "MYELOPROLIFERATIVE_DISEASE", headerName: "vte-risk-factor-evaluation.myeloproliferative-disease", flex: 1 },
        { field: "ELKTF_MJR_XTRMT_RTRPLY_SURGERY", headerName: "vte-risk-factor-evaluation.elective-major-arthroplasty", flex: 1 },
        { field: "HIP_PLVS_R_LWR_XTRMTY_FRACTURE", headerName: "vte-risk-factor-evaluation.hip-pelvis-fracture", flex: 1 },
        { field: "STROKE", headerName: "vte-risk-factor-evaluation.stroke", flex: 1 },
        { field: "ACUTE_SPINAL_CORD_INJURY", headerName: "vte-risk-factor-evaluation.acute-spinal-cord-injury", flex: 1 },
        { field: "CALC_VALUE", headerName: "score", flex: 0.5, type: "number" },
    ],
    rows: [
        { title: "id", value: "ID" },
        { title: "PROCESS_TIME", value: "PROCESS_TIME", type: "date" },
        { title: "HEIGHT", value: "HEIGHT" },
        { title: "WEIGHT", value: "WEIGHT" },
        { title: "VKI", value: "VKI" },
        { title: "AGE_PD_ID", value: "AGE_PD_ID_XNAME" },
        { title: "MINOR_SURGERY", value: "MINOR_SURGERY_XNAME" },
        { title: "PASSED_MAJOR_SURGERY", value: "PASSED_MAJOR_SURGERY_XNAME" },
        { title: "VARICOSE_VEINS", value: "VARICOSE_VEINS_XNAME" },
        { title: "INFLMMATRY_INTSTL_DISSE_STRY", value: "INFLMMATRY_INTSTL_DISSE_XNAME" },
        { title: "LEG_SWELLING_PRESENCE", value: "LEG_SWELLING_PRESENCE_XNAME" },
        { title: "VKI_PD_ID", value: "VKI_PD_ID_XNAME" },
        { title: "ACUTE_MYOCARDIAL_INFECTION", value: "ACUTE_MYOCARDIAL_INFECT_XNAME" },
        { title: "CONGESTIVE_HEART_FAILURE", value: "CONGESTIVE_HEART_FAILUR_XNAME" },
        { title: "DIABETES_MELLITUS_HYPERTENSION", value: "DIABETES_MELLITUS_HYPER_XNAME" },
        { title: "SEPSIS", value: "SEPSIS_XNAME" },
        { title: "PNEUMONIA", value: "PNEUMONIA_XNAME" },
        { title: "SERIOUS_PULMONARY_DISEASE", value: "SERIOUS_PULMONARY_DISEA_XNAME" },
        { title: "CHRNC_OBSTRCTVE_PLMNRY_DISEASE", value: "CHRNC_OBSTRCTVE_PLMNRY__XNAME" },
        { title: "PATIENT_REQUIRING_BED_REST", value: "PATIENT_REQUIRING_BED_R_XNAME" },
        { title: "BRTH_CNTRL_PHRM_OR_HRMN_USE", value: "BRTH_CNTRL_PHRM_OR_HRMN_XNAME" },
        { title: "PREGNANCY_OR_POSTPARTUM", value: "PREGNANCY_OR_POSTPARTUM_XNAME" },
        { title: "MISCARRIAGE_OR_STILLBIRTH", value: "MISCARRIAGE_OR_STILLBIR_XNAME" },
        { title: "SPINE_SURGERY", value: "SPINE_SURGERY_XNAME" },
        { title: "ARTHROSCOPIC_SURGERY", value: "ARTHROSCOPIC_SURGERY_XNAME" },
        { title: "ENDOSCOPIC_UROLOGICL_SURGERY", value: "ENDOSCOPIC_UROLOGICL_SU_XNAME" },
        { title: "MALIGNANCY", value: "MALIGNANCY_XNAME" },
        { title: "MAJOR_SURGERY", value: "MAJOR_SURGERY_XNAME" },
        { title: "LAPAROSCOPIC_SURGERY", value: "LAPAROSCOPIC_SURGERY_XNAME" },
        { title: "BEDRIDDEN_PATIENT", value: "BEDRIDDEN_PATIENT_XNAME" },
        { title: "IMMOBILIZATION", value: "IMMOBILIZATION_XNAME" },
        { title: "CENTRAL_VENOUS_CATATER", value: "CENTRAL_VENOUS_CATATER_XNAME" },
        { title: "PATIENT_USING_ANTIAGREGAN", value: "PATIENT_USING_ANTIAGREG_XNAME" },
        { title: "OPERA_HEART_SURGERY", value: "OPERA_HEART_SURGERY_XNAME" },
        { title: "DVT_PE_STORY", value: "DVT_PE_STORY_XNAME" },
        { title: "FAMILY_THROMBOSIS_STORY", value: "FAMILY_THROMBOSIS_STORY_XNAME" },
        { title: "HEPARININDUCED_THROMBCYTOPNI", value: "HEPARININDUCED_THROMBCY_XNAME" },
        { title: "CONJENTIAL_THROMBOPHILE_FACTRS", value: "CONJENTIAL_THROMBOPHILE_XNAME" },
        { title: "MYELOPROLIFERATIVE_DISEASE", value: "MYELOPROLIFERATIVE_DISE_XNAME" },
        { title: "ELKTF_MJR_XTRMT_RTRPLY_SURGERY", value: "ELKTF_MJR_XTRMT_RTRPLY__XNAME" },
        { title: "HIP_PLVS_R_LWR_XTRMTY_FRACTURE", value: "HIP_PLVS_R_LWR_XTRMTY_F_XNAME" },
        { title: "STROKE", value: "STROKE_XNAME" },
        { title: "MULTIPL_TRAUMA", value: "MULTIPL_TRAUMA_XNAME" },
        { title: "ACUTE_SPINAL_CORD_INJURY", value: "ACUTE_SPINAL_CORD_INJUR_XNAME" },
        { title: "CALC_VALUE", value: "CALC_VALUE" },
        { title: "CUSER", value: "CUSER" },
    ],
    mcpConfig: {
        AGE_PD_ID: { mcpId: 485, field: "AGE_PD_ID", scoreField: "AGE_PD_ID_XVALUE" },
        MINOR_SURGERY: { mcpId: 486, field: "MINOR_SURGERY", scoreField: "MINOR_SURGERY_XVALUE" },
        PASSED_MAJOR_SURGERY: { mcpId: 487, field: "PASSED_MAJOR_SURGERY", scoreField: "PASSED_MAJOR_SURGERY_XVALUE" },
        VARICOSE_VEINS: { mcpId: 488, field: "VARICOSE_VEINS", scoreField: "VARICOSE_VEINS_XVALUE" },
        INFLMMATRY_INTSTL_DISSE_STRY: { mcpId: 489, field: "INFLMMATRY_INTSTL_DISSE_STRY", scoreField: "INFLMMATRY_INTSTL_DISSE_XVALUE" },
        LEG_SWELLING_PRESENCE: { mcpId: 490, field: "LEG_SWELLING_PRESENCE", scoreField: "LEG_SWELLING_PRESENCE_XVALUE" },
        VKI_PD_ID: { mcpId: 491, field: "VKI_PD_ID", scoreField: "VKI_PD_ID_XVALUE" },
        ACUTE_MYOCARDIAL_INFECTION: { mcpId: 492, field: "ACUTE_MYOCARDIAL_INFECTION", scoreField: "ACUTE_MYOCARDIAL_INFECT_XVALUE" },
        CONGESTIVE_HEART_FAILURE: { mcpId: 493, field: "CONGESTIVE_HEART_FAILURE", scoreField: "CONGESTIVE_HEART_FAILUR_XVALUE" },
        DIABETES_MELLITUS_HYPERTENSION: { mcpId: 494, field: "DIABETES_MELLITUS_HYPERTENSION", scoreField: "DIABETES_MELLITUS_HYPER_XVALUE" },
        SEPSIS: { mcpId: 495, field: "SEPSIS", scoreField: "SEPSIS_XVALUE" },
        PNEUMONIA: { mcpId: 496, field: "PNEUMONIA", scoreField: "PNEUMONIA_XVALUE" },
        SERIOUS_PULMONARY_DISEASE: { mcpId: 497, field: "SERIOUS_PULMONARY_DISEASE", scoreField: "SERIOUS_PULMONARY_DISEA_XVALUE" },
        CHRNC_OBSTRCTVE_PLMNRY_DISEASE: { mcpId: 498, field: "CHRNC_OBSTRCTVE_PLMNRY_DISEASE", scoreField: "CHRNC_OBSTRCTVE_PLMNRY__XVALUE" },
        PATIENT_REQUIRING_BED_REST: { mcpId: 499, field: "PATIENT_REQUIRING_BED_REST", scoreField: "PATIENT_REQUIRING_BED_R_XVALUE" },
        BRTH_CNTRL_PHRM_OR_HRMN_USE: { mcpId: 500, field: "BRTH_CNTRL_PHRM_OR_HRMN_USE", scoreField: "BRTH_CNTRL_PHRM_OR_HRMN_XVALUE" },
        PREGNANCY_OR_POSTPARTUM: { mcpId: 501, field: "PREGNANCY_OR_POSTPARTUM", scoreField: "PREGNANCY_OR_POSTPARTUM_XVALUE" },
        MISCARRIAGE_OR_STILLBIRTH: { mcpId: 502, field: "MISCARRIAGE_OR_STILLBIRTH", scoreField: "MISCARRIAGE_OR_STILLBIR_XVALUE" },
        SPINE_SURGERY: { mcpId: 503, field: "SPINE_SURGERY", scoreField: "SPINE_SURGERY_XVALUE" },
        ARTHROSCOPIC_SURGERY: { mcpId: 504, field: "ARTHROSCOPIC_SURGERY", scoreField: "ARTHROSCOPIC_SURGERY_XVALUE" },
        ENDOSCOPIC_UROLOGICL_SURGERY: { mcpId: 505, field: "ENDOSCOPIC_UROLOGICL_SURGERY", scoreField: "ENDOSCOPIC_UROLOGICL_SU_XVALUE" },
        MALIGNANCY: { mcpId: 506, field: "MALIGNANCY", scoreField: "MALIGNANCY_XVALUE" },
        MAJOR_SURGERY: { mcpId: 507, field: "MAJOR_SURGERY", scoreField: "MAJOR_SURGERY_XVALUE" },
        LAPAROSCOPIC_SURGERY: { mcpId: 508, field: "LAPAROSCOPIC_SURGERY", scoreField: "LAPAROSCOPIC_SURGERY_XVALUE" },
        BEDRIDDEN_PATIENT: { mcpId: 509, field: "BEDRIDDEN_PATIENT", scoreField: "BEDRIDDEN_PATIENT_XVALUE" },
        IMMOBILIZATION: { mcpId: 510, field: "IMMOBILIZATION", scoreField: "IMMOBILIZATION_XVALUE" },
        CENTRAL_VENOUS_CATATER: { mcpId: 511, field: "CENTRAL_VENOUS_CATATER", scoreField: "CENTRAL_VENOUS_CATATER_XVALUE" },
        PATIENT_USING_ANTIAGREGAN: { mcpId: 512, field: "PATIENT_USING_ANTIAGREGAN", scoreField: "PATIENT_USING_ANTIAGREG_XVALUE" },
        OPERA_HEART_SURGERY: { mcpId: 513, field: "OPERA_HEART_SURGERY", scoreField: "OPERA_HEART_SURGERY_XVALUE" },
        DVT_PE_STORY: { mcpId: 514, field: "DVT_PE_STORY", scoreField: "DVT_PE_STORY_XVALUE" },
        FAMILY_THROMBOSIS_STORY: { mcpId: 515, field: "FAMILY_THROMBOSIS_STORY", scoreField: "FAMILY_THROMBOSIS_STORY_XVALUE" },
        HEPARININDUCED_THROMBCYTOPNI: { mcpId: 516, field: "HEPARININDUCED_THROMBCYTOPNI", scoreField: "HEPARININDUCED_THROMBCY_XVALUE" },
        CONJENTIAL_THROMBOPHILE_FACTRS: { mcpId: 517, field: "CONJENTIAL_THROMBOPHILE_FACTRS", scoreField: "CONJENTIAL_THROMBOPHILE_XVALUE" },
        MYELOPROLIFERATIVE_DISEASE: { mcpId: 518, field: "MYELOPROLIFERATIVE_DISEASE", scoreField: "MYELOPROLIFERATIVE_DISE_XVALUE" },
        ELKTF_MJR_XTRMT_RTRPLY_SURGERY: { mcpId: 519, field: "ELKTF_MJR_XTRMT_RTRPLY_SURGERY", scoreField: "ELKTF_MJR_XTRMT_RTRPLY__XVALUE" },
        HIP_PLVS_R_LWR_XTRMTY_FRACTURE: { mcpId: 520, field: "HIP_PLVS_R_LWR_XTRMTY_FRACTURE", scoreField: "HIP_PLVS_R_LWR_XTRMTY_F_XVALUE" },
        STROKE: { mcpId: 521, field: "STROKE", scoreField: "STROKE_XVALUE" },
        MULTIPL_TRAUMA: { mcpId: 522, field: "MULTIPL_TRAUMA", scoreField: "MULTIPL_TRAUMA_XVALUE" },
        ACUTE_SPINAL_CORD_INJURY: { mcpId: 523, field: "ACUTE_SPINAL_CORD_INJURY", scoreField: "ACUTE_SPINAL_CORD_INJUR_XVALUE" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
};
